import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import Container from "@material-ui/core/Container";
import CssBaseline from "@material-ui/core/CssBaseline";
import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { InputAdornment, IconButton } from "@material-ui/core";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Typography from "@material-ui/core/Typography";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { signUpAction } from "../../../../store/signup/actions";
import SelectableSearch from "../../base/views/SelectableSearch";
import LandingPageFooter from "../../LandingPage/views/LandingPageFooter";
import LandingPageHeader from "../../LandingPage/views/LandingPageHeader";
import {
  GetCityDropDownData,
  GetCountryDropDownData,
  GetStateDropDownData,
  GetZipDetails,
} from "../../SignUp/helper/signUpHelper";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  Appcss: {
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(6px)",
    borderRadius: "15px",
    padding: "30px",
    marginTop: "5%",
    justifyContent: "center",
    alignItems: "center",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function SignUp() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [countryData, setCountryData] = useState({
    load: false,
    values: [],
  });
  const [stateData, setStateData] = useState({
    load: false,
    values: [],
  });
  const [cityData, setCityData] = useState({
    load: false,
    values: [],
  });
  const [signUpData, setState] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    email: "",
    mobileno: "",
    password: "",
    confirmPassword: "",
    street1: "",
    street2: "",
    zipcode: "",
    selectedCountry: { id: 0, optionname: "" },
    selectedState: { id: 0, optionname: "" },
    selectedCity: { id: 0, optionname: "" },
  });
  const history = useHistory();
  const [errors, setErrors] = React.useState({});

  const validate = (fieldValues = signUpData) => {
    let temp = { ...errors };

    if ("firstName" in fieldValues) {
      temp.firstName =
        fieldValues.firstName === "" ? "First Name is required" : "";
    }

    if ("middleName" in fieldValues) {
      temp.middleName =
        fieldValues.middleName === "" ? "Middle Name is required" : "";
    }

    if ("lastName" in fieldValues) {
      temp.lastName =
        fieldValues.lastName === "" ? "Last Name is required" : "";
    }

    if ("email" in fieldValues) {
      temp.email =
        fieldValues.email === ""
          ? "Email is required"
          : /$^|.+@.+..+/.test(fieldValues.email)
          ? ""
          : "Invalid Email.";
    }

    if ("mobileno" in fieldValues) {
      temp.mobileno =
        fieldValues.mobileno === ""
          ? "Mobile No is required"
          : fieldValues.mobileno.length !== 10
          ? "Mobile No should have 10 digits"
          : "";
    }
    if ("password" in fieldValues) {
      temp.password = fieldValues.password === "" ? "Password is required" : "";
    }

    if ("confirmPassword" in fieldValues) {
      temp.confirmPassword =
        fieldValues.confirmPassword === ""
          ? "Confirm Password is required"
          : fieldValues.password === fieldValues.confirmPassword
          ? ""
          : "Passwords does not match";
    }

    if ("street1" in fieldValues) {
      temp.street1 = fieldValues.street1 === "" ? "Street 1 is required" : "";
    }

    if ("zipcode" in fieldValues) {
      temp.zipcode = fieldValues.zipcode === "" ? "Zip Code is required" : "";
    }

    if ("selectedCountry" in fieldValues) {
      temp.selectedCountry =
        fieldValues.selectedCountry.optionname === ""
          ? "Country is required"
          : "";
    }

    if ("selectedState" in fieldValues) {
      temp.selectedState =
        fieldValues.selectedState.optionname === "" ? "State is required" : "";
    }

    if ("selectedCity" in fieldValues) {
      temp.selectedCity =
        fieldValues.selectedCity.optionname === "" ? "City is required" : "";
    }

    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === "");
  };

  const updateField = (e) => {
    setState({
      ...signUpData,
      [e.target.name]: e.target.value,
    });
  };

  const updateZipField = (e) => {
    setState({
      ...signUpData,
      [e.target.name]: e.target.value,
    });
    var params = { zipcode: e.target.value };

    GetZipDetails(params).then((response) => {
      if (response && response.length) {
        var countryResponse = {
          id: response[0].country_id,
          optionname: response[0].country_name,
        };
        var stateResponse = {
          id: response[0].state_id,
          optionname: response[0].state_name,
        };
        var cityResponse = {
          id: response[0].city_id,
          optionname: response[0].city_name,
        };
        setState({
          ...signUpData,
          selectedCountry: {
            id: countryResponse.id,
            optionname: countryResponse.optionname,
          },
          selectedState: {
            id: stateResponse.id,
            optionname: stateResponse.optionname,
          },
          selectedCity: {
            id: cityResponse.id,
            optionname: cityResponse.optionname,
          },
          zipcode: params.zipcode,
        });
      } else {
        setState({
          ...signUpData,
          selectedCountry: {},
          selectedState: {},
          selectedCity: {},
          zipcode: params.zipcode,
        });
      }
    });
  };

  const checkPassword = (e) => {
    if (e.target.name === "password") {
      setErrors({
        ...errors,
        [e.target.name]: new RegExp(
          "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#%^&*])(?=.{8,})"
        ).test(e.target.value)
          ? ""
          : "Password must contain min 8-char, 1 A-Z character, 1 a-z character, 1 number and 1 special character",
      });
    } else if (e.target.name === "confirmPassword") {
      setErrors({
        ...errors,
        [e.target.name]:
          e.target.value === signUpData.password
            ? ""
            : "Passwords does not match",
      });
    }
  };

  const handleCountryChange = (event, value) => {
    if (value && value.id) {
      setState({
        ...signUpData,
        selectedCountry: { id: value.id, optionname: value.optionname },
        selectedState: {},
        selectedCity: {},
        zipcode: "",
      });
    } else {
      setState({
        ...signUpData,
        selectedCountry: {},
        selectedState: {},
        selectedCity: {},
        zipcode: "",
      });
    }
    setStateData({ ...stateData, values: [] });
    setCityData({ ...cityData, values: [] });
  };

  const handleStateChange = (event, value) => {
    setCityData({ ...cityData, values: [] });
    if (value && value.id) {
      setState({
        ...signUpData,
        selectedState: {
          id: value.id,
          optionname: value.optionname,
          selectedCity: {},
          zipcode: "",
        },
      });
    } else {
      setState({
        ...signUpData,
        selectedState: {},
        selectedCity: {},
        zipcode: "",
      });
    }
  };

  const handleCityChange = (event, value) => {
    if (value && value.id) {
      setState({
        ...signUpData,
        selectedCity: { id: value.id, optionname: value.optionname },
        zipcode: "",
      });
    } else {
      setState({
        ...signUpData,
        selectedCity: {},
        zipcode: "",
      });
    }
  };

  const loadingCountry = () => {
    setCountryData({ ...countryData, load: true });
    GetCountryDropDownData()
      .then((response) => {
        setCountryData({ load: false, values: response });
      })
      .catch((err) => {});
  };

  const loadingState = (countryId = 0) => {
    setStateData({ ...stateData, load: true });
    var params = { country_id: countryId };
    GetStateDropDownData(params)
      .then((response) => {
        setStateData({ load: false, values: response });
      })
      .catch((err) => {});
  };

  const loadingCity = (stateId = 0) => {
    setCityData({ ...cityData, load: true });
    var params = { state_id: stateId };
    GetCityDropDownData(params)
      .then((response) => {
        setCityData({ load: false, values: response });
      })
      .catch((err) => {});
  };

  const SubmitSignUp = (e) => {
    e.preventDefault();
    let data = {};
    for (var key in signUpData) {
      if (key !== "confirmPassword") data[key] = signUpData[key];
    }

    if (validate()) {
      dispatch(signUpAction(data));
    }
  };

  return (
    <React.Fragment>
      <LandingPageHeader />
      <Container component="main" maxWidth="lg">
        <CssBaseline />
        <Container maxWidth="md" className={classes.Appcss}>
          <div className={classes.paper}>
            <Avatar className={classes.avatar} style={{ backgroundColor: "rgb(22, 177, 255)" }}>
              <AccountCircleIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              Sign up
            </Typography>
            <div className={classes.form}>
              <Grid container spacing={3}>
                <Grid item xs={4}>
                  <TextField
                    required
                    value={signUpData.firstName}
                    onChange={updateField}
                    autoComplete="fname"
                    name="firstName"
                    variant="outlined"
                    fullWidth
                    id="firstName"
                    label="First Name"
                    autoFocus
                    {...(errors.firstName && {
                      error: true,
                      helperText: errors.firstName,
                    })}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    value={signUpData.middleName}
                    onChange={updateField}
                    variant="outlined"
                    fullWidth
                    id="middleName"
                    label="Middle Name"
                    name="middleName"
                    autoComplete="mname"
                    {...(errors.middleName && {
                      error: true,
                      helperText: errors.middleName,
                    })}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    required
                    value={signUpData.lastName}
                    onChange={updateField}
                    variant="outlined"
                    fullWidth
                    id="lastName"
                    label="Last Name"
                    name="lastName"
                    autoComplete="lname"
                    {...(errors.lastName && {
                      error: true,
                      helperText: errors.lastName,
                    })}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    required
                    value={signUpData.email}
                    onChange={updateField}
                    variant="outlined"
                    fullWidth
                    id="email"
                    label="Email Address"
                    name="email"
                    autoComplete="email"
                    {...(errors.email && {
                      error: true,
                      helperText: errors.email,
                    })}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    value={signUpData.mobileNo}
                    onChange={updateField}
                    variant="outlined"
                    required
                    fullWidth
                    id="mobileno"
                    label="Mobile No"
                    name="mobileno"
                    autoComplete="mobileno"
                    {...(errors.mobileno && {
                      error: true,
                      helperText: errors.mobileno,
                    })}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    required
                    value={signUpData.password}
                    onChange={(e) => {
                      updateField(e);
                      checkPassword(e);
                    }}
                    variant="outlined"
                    fullWidth
                    name="password"
                    label="Password"
                    type={showPassword ? "text" : "password"}
                    id="password"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => {
                              setShowPassword(!showPassword);
                            }}
                          >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    autoComplete="current-password"
                    {...(errors.password && {
                      error: true,
                      helperText: errors.password,
                    })}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    required
                    value={signUpData.confirmPassword}
                    onChange={(e) => {
                      updateField(e);
                      checkPassword(e);
                    }}
                    variant="outlined"
                    fullWidth
                    name="confirmPassword"
                    label="Confirm Password"
                    type={showConfirmPassword ? "text" : "password"}
                    id="confirmPassword"
                    autoComplete="current-password"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => {
                              setShowConfirmPassword(!showConfirmPassword);
                            }}
                          >
                            {showConfirmPassword ? (
                              <Visibility />
                            ) : (
                              <VisibilityOff />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    {...(errors.confirmPassword && {
                      error: true,
                      helperText: errors.confirmPassword,
                    })}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    required
                    value={signUpData.street1}
                    onChange={updateField}
                    variant="outlined"
                    fullWidth
                    name="street1"
                    label="Street 1"
                    type="street1"
                    id="street1"
                    autoComplete="street1"
                    {...(errors.street1 && {
                      error: true,
                      helperText: errors.street1,
                    })}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    value={signUpData.street2}
                    onChange={updateField}
                    variant="outlined"
                    fullWidth
                    name="street2"
                    label="Street 2"
                    type="street2"
                    id="street2"
                    autoComplete="street2"
                    {...(errors.street2 && {
                      error: true,
                      helperText: errors.street2,
                    })}
                  />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    required
                    value={signUpData.zipcode}
                    onChange={updateZipField}
                    variant="outlined"
                    fullWidth
                    name="zipcode"
                    label="Zip Code"
                    type="zipcode"
                    id="zipcode"
                    autoComplete="zipcode"
                    {...(errors.zipcode && {
                      error: true,
                      helperText: errors.zipcode,
                    })}
                  />
                </Grid>
                <Grid item xs={3}>
                  <SelectableSearch
                    required
                    value={signUpData.selectedCity}
                    data={cityData}
                    name="city"
                    label="City"
                    id="city"
                    loading={() => loadingCity(signUpData.selectedState.id)}
                    onChangeEvent={handleCityChange}
                    {...(errors.selectedCity && {
                      error: true,
                      helperText: errors.selectedCity,
                    })}
                  ></SelectableSearch>
                </Grid>
                <Grid item xs={3}>
                  <SelectableSearch
                    required
                    value={signUpData.selectedState}
                    data={stateData}
                    name="state"
                    label="State"
                    id="state"
                    loading={() => loadingState(signUpData.selectedCountry.id)}
                    onChangeEvent={handleStateChange}
                    {...(errors.selectedState && {
                      error: true,
                      helperText: errors.selectedState,
                    })}
                  ></SelectableSearch>
                </Grid>
                <Grid item xs={3}>
                  <SelectableSearch
                    required
                    value={signUpData.selectedCountry}
                    data={countryData}
                    name="country"
                    label="Country"
                    id="country"
                    loading={loadingCountry}
                    onChangeEvent={handleCountryChange}
                    {...(errors.selectedCountry && {
                      error: true,
                      helperText: errors.selectedCountry,
                    })}
                  ></SelectableSearch>
                </Grid>
              </Grid>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Button
                  fullWidth
                  type="submit"
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                  onClick={SubmitSignUp}
                  style={{
                    width: "20vw",
                    backgroundColor: "rgb(22, 177, 255)",
                  }}
                >
                  Sign Up
                </Button>
              </div>

              <Grid container justify="center">
                <Grid item>
                  <Link onClick={() => history.push("/")} variant="body2">
                    Already have an account? Sign in
                  </Link>
                </Grid>
              </Grid>
            </div>
          </div>
        </Container>
      </Container>
      <LandingPageFooter />
    </React.Fragment>
  );
}
